export function UTCToJapanTime(utcTime: string): any {
  if (utcTime.length === 0) {
    return {
      year: "yyyy",
      month: "mm",
      day: "dd",
      hour: "hh",
      minute: "mm",
      second: "ss",
    };
  }
  const date = new Date(utcTime);

  const formatter = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Tokyo",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });

  const parts = formatter.formatToParts(date);
  const month = parts.find((part) => part.type === "month")?.value || "0";
  const day = parts.find((part) => part.type === "day")?.value || "0";
  const minute = parts.find((part) => part.type === "minute")?.value || "0";

  return {
    year: parseInt(parts.find((part) => part.type === "year")?.value || "0"),
    month: month.padStart(2, "0"),
    day: day.padStart(2, "0"),
    hour: parseInt(parts.find((part) => part.type === "hour")?.value || "0"),
    minute: minute.padStart(2, "0"),
    second: parseInt(
      parts.find((part) => part.type === "second")?.value || "0",
    ),
  };
}

export function getDiffTime(utcTime: string): string {
  const inputDate = new Date(utcTime);
  const currentDate = new Date();

  const diffMs = currentDate.getTime() - inputDate.getTime();

  const diffSeconds = Math.floor(diffMs / 1000);
  const diffMinutes = Math.floor(diffSeconds / 60);
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);
  const diffWeeks = Math.floor(diffDays / 7);
  const diffMonths = Math.floor(diffDays / 30);
  const diffYears = Math.floor(diffDays / 365);

  if (diffMs < 0) {
    return "たった今";
  }

  if (diffSeconds < 60) {
    return "たった今";
  } else if (diffMinutes < 60) {
    return `${diffMinutes}分前`;
  } else if (diffHours < 24) {
    return `${diffHours}時間前`;
  } else if (diffDays < 7) {
    return `${diffDays}日前`;
  } else if (diffWeeks < 4) {
    return `${diffWeeks}週間前`;
  } else if (diffMonths < 12) {
    return `${diffMonths}ヶ月前`;
  } else {
    return `${diffYears}年前`;
  }
}
